import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const hand_sbb_297_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <g fill="none" fillRule="evenodd">
        <path
          stroke={iconColor}
          d="M8.8613,17.028 L4.1263,13.72 C3.6953,13.375 3.0663,13.443 2.7203,13.874
        C2.3743,14.304 2.4433,14.934 2.8743,15.28 L8.7993,20.5 L12.7423,20.5 L13.7503,21.5 L21.2003,21.5
        L16.1723,16.436 C15.0353,15.342 13.5883,14.528 12.1093,14.5 L10.0003,14.5 C8.0153,14.5 7.9683,17.5
        10.0003,17.5 L12.0003,17.5"
        />
        <polygon
          fill={iconColor}
          points="10.474 4 13.219 6.704 9.807 6.704 9.807 4 8.193 4 8.193 6.704 4.8
        6.704 7.544 4 5.504 4 2 7.5 5.504 11 7.544 11 4.8 8.314 8.193 8.314 8.193 11 9.807 11 9.807 8.314
        13.219 8.314 10.474 11 12.514 11 16 7.5 12.514 4"
        />
      </g>
    </svg>
  );
};
